import React from 'react';
import PropTypes from 'prop-types';

import {createForm} from '@utils/forms';
import ClientAvApiKeyModel from '@modules/client/forms/ClientAvApiKeyModel';
import ClientAvApiKeyForm from '@modules/client/forms/ClientAvApiKeyForm';
import ClientAvApiKeyModelEdit from '@modules/client/forms/ClientAvApiKeyModelEdit';
import {convertToInt} from '@utils/helpers';

const ClientAvApiKeyModalContent = ({
    clientId,
    bookmakerId,
    clientApiKeyId,
    isAddForm = false,
}) => {
    let Form;

    if (isAddForm) {
        Form = createForm(
            ClientAvApiKeyModel,
            ClientAvApiKeyForm,
            {
                clientId: clientId,
                bookmakerId: bookmakerId,
            }
        );
    } else {
        Form = createForm(
            ClientAvApiKeyModelEdit,
            ClientAvApiKeyForm,
            {
                id: clientApiKeyId,
                clientId: clientId,
                dataRequest: true,
                optionsVariables: {
                    id: convertToInt(clientId),
                },
            }
        );
    }

    return <Form />;
};

ClientAvApiKeyModalContent.propTypes = {
    clientId: PropTypes.number,
    bookmakerId: PropTypes.number,
    clientApiKeyId: PropTypes.number,
    isAddForm: PropTypes.bool,
};
export default ClientAvApiKeyModalContent;
